import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import I18n from '@module/i18n';

import { clickLegal } from '@module/consent-manager/tracker';

export function Intro({ children, isInPanel }) {
  const element = useRef(null);
  const legalPageHref = '/legal/manage-cookies';

  useEffect(() => {
    const legalLinks = element.current.querySelectorAll(
      `a[href="${legalPageHref}"]`
    );
    if (legalLinks) {
      Array.from(legalLinks).forEach((legalLink) => {
        legalLink.onclick = clickLegal;
      });
    }
  }, [element]);

  const content = {
    intro: {
      __html: I18n.t('transfer.consent-manager.intro', {
        href: legalPageHref,
      }),
    },
    text: {
      __html: I18n.t('transfer.consent-manager.text', {
        href: legalPageHref,
      }),
    },
    textPanel: {
      __html: I18n.t('transfer.consent-manager.text-panel', {
        href: legalPageHref,
      }),
    },
  };

  return (
    <div className="welcome__consent-splash" ref={element}>
      <div
        className="welcome__cookie-notice-title"
        dangerouslySetInnerHTML={content.title}
      />
      <div
        className="welcome__cookie-notice-intro"
        dangerouslySetInnerHTML={content.intro}
      />
      {isInPanel ? (
        <div
          className="welcome__cookie-notice-text"
          dangerouslySetInnerHTML={content.textPanel}
        />
      ) : (
        <div
          className="welcome__cookie-notice-text"
          dangerouslySetInnerHTML={content.text}
        />
      )}
      <div className="welcome__buttons">{children}</div>
    </div>
  );
}

Intro.propTypes = {
  children: PropTypes.node,
  isInPanel: PropTypes.bool,
};

Intro.defaultProps = {
  isInPanel: false,
};
